<li class="list-item btn">
    <h3>{{item.id}}</h3>
    <p>{{item.type}}</p>
</li>
